// @flow

const botSettingsScriptStyles = {
  cardCtr: (theme) => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    maxWidth: 600,
    borderRadius: 0
  }),

  textFieldCtr: (theme) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(2),
    border: `2px solid ${theme.palette.primary.lighter}`
  }),

  textField: (theme) => ({
    marginTop: theme.spacing(1)
  }),

  stepTitle: (theme) => ({
    marginBottom: theme.spacing(1)
  }),

  chip: (theme) => ({
    // If your theme has custom colors:
    backgroundColor: theme.palette.custom?.neoYellow?.main || '#FFFF00',
    color: theme.palette.custom?.neoViolet?.main || '#000000',
    fontWeight: 700,
    marginRight: theme.spacing(0.5)
  }),

  submitBtn: (theme) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2)
  }),

  knownScriptCtr: (theme) => ({
    marginTop: theme.spacing(4)
  })
};

export default botSettingsScriptStyles;